(function () {
  'use strict';
  var googleStarted = false;
  function startGoogle() {
    if (googleStarted) return;
    googleStarted = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-787319885';
    document.head.appendChild(script);
    window.gtag('config', 'AW-787319885');
  }
  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var analytics = privacy.analyticsProcessingAllowed();
    var marketing = privacy.marketingAllowed();
    var sharing = privacy.saleOfDataAllowed();
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing && sharing ? 'granted' : 'denied',
        ad_personalization: marketing && sharing ? 'granted' : 'denied'
      });
    }
    if (analytics && marketing) startGoogle();
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  function init() {
    if (!window.Shopify) return;
    if (window.Shopify.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
